module.exports = __webpack_public_path__ + "static/media/6510.0a575ee7.jpg";